import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/views/theme/Base"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/views/pages/Dashboard.vue")
        },
        {
          path: "/document",
          name: "document",
          redirect: '/document/list',
          component: () =>
            import("@/views/pages/document/Document.vue"),
          children: [
            {
              path: "history",
              name: "document-history",
              component: () => import("@/views/pages/document/History.vue")
            },
            {
              path: "history-drafts",
              name: "document-history-drafts",
              component: () => import("@/views/pages/document/History.vue")
            },
            {
              path: "list",
              name: "document-list",
              component: () => import("@/views/pages/document/List.vue")
            },
            {
              path: "edit/:id?",
              name: "document-edit",
              component: () => import("@/views/pages/document/Edit.vue")
            },
            {
              path: "edit/:did/template/:id?",
              name: "document-edit-template",
              component: () => import("@/views/pages/document/EditTemplate.vue")
            },
            {
              path: "form/:id",
              name: "document-form",
              component: () => import("@/views/pages/document/Form.vue")
            },
            {
              path: "form/:id/submission/:sid/view",
              name: "document-submission-view",
              component: () => import("@/views/pages/document/Form.vue")
            },
            {
              path: "form/:id/draft/:sid/view",
              name: "document-draft-view",
              component: () => import("@/views/pages/document/Form.vue")
            },
            {
              path: "form/:id/submissioncopy/:csid/view",
              name: "document-submission-copy",
              component: () => import("@/views/pages/document/Form.vue")
            },
            {
              path: "form/:id/submissionrecopy/:csid/view",
              name: "document-submission-recopy",
              component: () => import("@/views/pages/document/Form.vue")
            }
          ]
        },
        {
          path: "/ext-crm",
          name: "ext-crm",
          component: () =>
                import("@/views/pages/ext-crm/Index.vue"),
          children: [
            {
              path: "edit/:id?",
              name: "ext-crm-edit",
              component: () => import("@/views/pages/ext-crm/Edit.vue")
            },
            {
              path: "list",
              name: "ext-crm-list",
              component: () => import("@/views/pages/ext-crm/List.vue")
            },
          ]
        },
        {
          path: "/setting",
          name: "document",
          component: () =>
            import("@/views/pages/setting/Setting.vue"),
          children: [
            {
              path: "user/editc",
              name: "setting-user-edit-current",
              component: () => import("@/views/pages/setting/user/EditCurrent.vue")
            },
            {
              path: "user/edit/:id?",
              name: "setting-user-edit",
              component: () => import("@/views/pages/setting/user/Edit.vue")
            },
            {
              path: "user/list",
              name: "setting-user-list",
              component: () => import("@/views/pages/setting/user/List.vue")
            },
            {
              path: "user/change-password",
              name: "force-change-password",
              component: () => import("@/views/pages/setting/user/ForceChangePassword.vue")
            },
            {
              path: "estrasf",
              name: "setting-estrasf-credentials",
              component: () => import("@/views/pages/setting/estrasf/Credentials.vue")
            },
          ]
        },
        {
          path: "/setting-organization",
          name: "document",
          component: () =>
            import("@/views/pages/setting-organization/Setting.vue"),
          children: [
            {
              path: "user/edit/:id?",
              name: "setting-organization-user-edit",
              component: () => import("@/views/pages/setting-organization/user/Edit.vue")
            },
            {
              path: "user/list",
              name: "setting-organization-user-list",
              component: () => import("@/views/pages/setting-organization/user/List.vue")
            },
            {
              path: "group/edit/:id?",
              name: "setting-organization-group-edit",
              component: () => import("@/views/pages/setting-organization/group/Edit.vue")
            },
            {
              path: "group/list",
              name: "setting-organization-group-list",
              component: () => import("@/views/pages/setting-organization/group/List.vue")
            },
          ]
        },
        {
          path: "/setting-admin",
          name: "document",
          component: () =>
            import("@/views/pages/setting-admin/Setting.vue"),
          children: [
            {
              path: "main/edit/:id?",
              name: "setting-admin-main-edit",
              component: () => import("@/views/pages/setting-admin/main/Edit.vue")
            },
            {
              path: "main/list",
              name: "setting-admin-main-list",
              component: () => import("@/views/pages/setting-admin/main/List.vue")
            },
          ]
        }
      ]
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/views/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/views/pages/error/Error-1.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/views/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/views/pages/auth/Login")
        },
        {
          name: "loginrecover",
          path: "/loginrecover",
          component: () => import("@/views/pages/auth/Recover")
        },
        {
          name: "loginreset",
          path: "/loginreset/:email",
          component: () => import("@/views/pages/auth/Reset")
        }
        // {
        //   name: "register",
        //   path: "/register",
        //   component: () => import("@/views/pages/auth/Register")
        // }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/views/pages/error/Error-1.vue")
    }
  ]
});

// Handle chunk loading errors when code is updated
router.onError((error, to) => {
  // Detect various chunk loading errors from different bundlers
  const isChunkLoadError =
    error.message.includes('Failed to fetch dynamically imported module') || // Vite
    error.message.includes('Importing a module script failed') ||           // Vite/Modern browsers
    error.message.includes('error loading dynamically imported module') ||   // Vite variation
    /Loading chunk .+ failed/.test(error.message) ||                        // Webpack
    /ChunkLoadError/.test(error.name) ||                                    // Webpack
    error.message.includes('Failed to fetch') && error.stack?.includes('import'); // Generic dynamic import

  if (isChunkLoadError) {
    const reloadKey = 'chunk-reload-attempt';
    const reloadCountKey = 'chunk-reload-count';
    const now = Date.now();
    const lastReload = sessionStorage.getItem(reloadKey);
    const reloadCount = parseInt(sessionStorage.getItem(reloadCountKey) || '0');

    // Prevent infinite reload loops:
    // 1. Check if we recently reloaded (within last 10 seconds)
    // 2. Check if the reload query param is already present
    // 3. Limit to 3 reload attempts to handle broken deployments
    if (lastReload && now - parseInt(lastReload) < 10000) {
      console.error('Chunk load error detected, but recent reload attempt failed. Not reloading again to prevent loop.');
      console.error('Original error:', error);
      console.error('Please manually refresh the page or contact support if the issue persists.');
      return;
    }

    if (to?.query?.reload) {
      console.error('Chunk load error detected, but reload already attempted. Not reloading again to prevent loop.');
      console.error('Original error:', error);
      sessionStorage.removeItem(reloadKey);
      return;
    }

    if (reloadCount >= 3) {
      console.error('Chunk load error detected, but maximum reload attempts reached (3). Not reloading again.');
      console.error('Original error:', error);
      console.error('Please manually refresh the page or clear your browser cache.');
      sessionStorage.removeItem(reloadKey);
      sessionStorage.removeItem(reloadCountKey);
      return;
    }

    // Log the reload attempt for debugging
    console.warn('Chunk load error detected. This usually means the app was updated. Reloading page...');
    console.warn('Error details:', error.message);
    console.warn(`Reload attempt ${reloadCount + 1} of 3`);

    // Store the reload timestamp and increment counter
    sessionStorage.setItem(reloadKey, now.toString());
    sessionStorage.setItem(reloadCountKey, (reloadCount + 1).toString());

    // Reload the page with the target route
    const targetPath = to?.fullPath || window.location.pathname + window.location.search;
    const separator = targetPath.includes('?') ? '&' : '?';
    window.location.assign(targetPath + separator + 'reload=true');
  }
});

// Clean up reload flags on successful navigation
router.afterEach(() => {
  // Remove the reload tracking from sessionStorage after successful navigation
  // This allows future updates to trigger reloads again
  sessionStorage.removeItem('chunk-reload-attempt');
  sessionStorage.removeItem('chunk-reload-count');
});

export default router;
